/**
 * The busy cursor while a quick save runs in the background (a favourite, the cart):
 * the arrow with a small spinner, so the person still sees their click is working
 * without a spinner on the icon, and can keep browsing meanwhile.
 *
 * Several saves can overlap: the cursor stays until the last one settles. Does
 * nothing on the server (no document).
 */
let pending = 0;

const setBusy = busy => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('busyCursor', busy);
};

/** Show the busy cursor until `promise` settles; returns the same promise's result. */
export const withBusyCursor = promise => {
  pending += 1;
  setBusy(true);
  const done = () => {
    pending = Math.max(0, pending - 1);
    if (pending === 0) setBusy(false);
  };
  return Promise.resolve(promise).finally(done);
};
